import request from '../../config/axiosConfig';
import { GET_DATA_STATISTICS, GET_GRAPHICAL_STATISTICS } from '../../constants/apiEndPoint';

export const getDataStatisticVideoRequest = async (data) => {
  const result = await request({
    url: GET_DATA_STATISTICS,
    method: 'POST',
    data,
  });
  return result?.data?.data;
};

export const getGraphicalStatisticVideoRequest = async (data) => {
  const result = await request({
    url: GET_GRAPHICAL_STATISTICS,
    method: 'POST',
    data,
  });
  return result?.data;
};
